import React from 'react';
import PropTypes from 'prop-types';
import { SAVE_ERROR, SAVE_SUCCESS } from '../../constants/preferences';
import Heart from './Heart';
import Caution from './Caution';

const PreferenceStatus = ({ saveState, style }) => {
  switch (saveState) {
    case SAVE_SUCCESS:
      return <Heart style={style} />;
    case SAVE_ERROR:
      return <Caution style={style} />;
    default:
      return null;
  }
};

PreferenceStatus.propTypes = {
  status: PropTypes.oneOf([SAVE_SUCCESS, SAVE_ERROR]),
};

export default PreferenceStatus;
